import React, { Component, Fragment } from 'react';
import { inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import CategoryTable from 'modules/budget/components/category/category-table/category-table';
import Description from 'modules/budget/components/category/description';

@inject('store')
class CategoryPage extends Component {
    componentDidMount() {
        const { store } = this.props;
        store.app.setPageTitle('BUDGET.CATEGORY_PAGE.PAGE_TITLE');

        store.categories.requestCategories();
        store.categories.requestHidden();
    }

    render() {
        //const { store } = this.props;
        //const { categories, loading } = store.categories;

        return (
            <Fragment>
                <Helmet>
                    <title>Categories</title>
                </Helmet>

                <div className="container container-fixed-lg mt-3">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="card table-responsive">
                                <div className="card-header">
                                    <h2 className="card-title">Visible Categories</h2>
                                </div>
                                <CategoryTable />
                            </div>
                            <div className="card table-responsive">
                                <div className="card-header">
                                    <h2 className="card-title">Hidden Categories</h2>
                                </div>
                                <CategoryTable hidden={true} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <Description />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default CategoryPage;


// WEBPACK FOOTER //
// ./src/modules/budget/pages/category-page.js